import { Behavior } from "./Behavior";
import { ComponentTooltipHandler } from "./ComponentTooltipHandler";
import { Component } from "./Component";

export class ComponentTooltipHandlerBehavior extends Behavior {
    protected constructor() {
        super();
    }

    public shouldPreventTooltipDisplay(component: Component): boolean {
        return component._designer != null && component["_allowTooltipInDesigner"] !== true;
    }

    get type(): string {
        return "ComponentTooltipHandler";
    }
}

ComponentTooltipHandlerBehavior.register();
